import { render, staticRenderFns } from "./printTagNew.vue?vue&type=template&id=0c57fa1e&"
import script from "./printTagNew.vue?vue&type=script&setup=true&lang=ts&"
export * from "./printTagNew.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./printTagNew.vue?vue&type=style&index=0&id=0c57fa1e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports